<template>
    <v-speed-dial
            v-model="show"
            :top="true"
            :right="true"
            direction="bottom"
            :open-on-hover="true"
            transition="slide-y-transition">
        <v-btn  slot="activator"
                v-model="show"
                color="blue darken-2"
                dark
                fab>
            <v-icon>account_circle</v-icon>
            <v-icon>close</v-icon>
        </v-btn>
        <!--lets have edit and other users setting on this dial as well. FOr now just logOut -->
        <logOut></logOut>
    </v-speed-dial>
</template>

<script>
    const logOut = () => import ('@/components/common/cognito/LogOut');

    export default {
        name: "userDial",
        components: {
          logOut
        },
        data(){
           return { show: false}
        }
    }
</script>

<style scoped>
    button:focus, button:active, button.active, button:focus:active {
        background-image: none;
        outline: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
</style>